export const config = {
  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '通道code',
          key: 'code',
          width: 130,
          align: 'center',
          tooltip:true
        },
        {
          title: '通道简称',
          key: 'name',
          minWidth: 150,
          align: 'center',
        },
        {
          title: '通道全称',
          key: 'fullName',
          minWidth: 200,
          align: 'center',
        },
        {
          title: '通道性质',
          key: 'channelType',
          minWidth: 100,
          align: 'center',
          tooltip:true,
          render: (h, params) => {
            let text = ""
            if(params.row.channelType==1){
              text = "总公司"
            }else if(params.row.channelType==2){
              text = "分公司"
            }
            return h('span', [
              text
            ])
          },
        },
        {
          title:"所在地区",
          minWidth: 100,
          align: "center",
          tooltip: true,
          render: (h, params) => {
            return h('span', [params.row.province,'-' ,params.row.city]);    
          },
        },
        {
          title: '操作',
          slot: 'action',
          width: 200,
          align: 'center',
        },
      ],
    }
  },
  methods: {

  }
}
